export default "/images/18.png?1a7dc2ff77d881bd95aae61ff342d72f";